import { c as _c } from "react/compiler-runtime";
import React from "react";
import { UseFormRegister, FieldError } from "react-hook-form";
import styles from "@/features/partner-with-us/BusinessDetailsForm/main.module.css";
interface FormFieldProps {
  label: string;
  name: string;
  type?: string;
  placeholder?: string;
  register: UseFormRegister<any>;
  validation?: any;
  error?: FieldError;
  disabled?: boolean;
}
const FormField: React.FC<FormFieldProps> = t0 => {
  const $ = _c(17);
  const {
    label,
    name,
    type: t1,
    placeholder,
    register,
    validation,
    error,
    disabled: t2
  } = t0;
  const type = t1 === undefined ? "text" : t1;
  const disabled = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== label) {
    t3 = <label className={styles.label}>{label}</label>;
    $[0] = label;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== name || $[3] !== register || $[4] !== validation) {
    t4 = register(name, validation);
    $[2] = name;
    $[3] = register;
    $[4] = validation;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== disabled || $[7] !== placeholder || $[8] !== t4 || $[9] !== type) {
    t5 = <input type={type} placeholder={placeholder} {...t4} disabled={disabled} className={styles.input} />;
    $[6] = disabled;
    $[7] = placeholder;
    $[8] = t4;
    $[9] = type;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== error) {
    t6 = error && <p className={styles.errorMessage}>{error.message}</p>;
    $[11] = error;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t3 || $[14] !== t5 || $[15] !== t6) {
    t7 = <div className={styles.fieldContainer}>{t3}{t5}{t6}</div>;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
export default FormField;